import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // ✅ import navigate hook

function Login({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate(); // ✅ initialize navigate
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
const res = await axios.post(`${API_BASE_URL}/api/internal-users/login`, form);
      const { token, user } = res.data;


  // ✅ Save token and user info (use 'adminToken' for consistency)
  localStorage.setItem('adminToken', token);
  localStorage.setItem('user', JSON.stringify(user));

      if (onLogin) onLogin(user);

      // ✅ Redirect to dashboard
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError('Invalid email or password');
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ height: '100vh' }}>
      <form className="card p-4 shadow-sm" onSubmit={handleSubmit} style={{ width: 400 }}>
        <h4 className="mb-3 text-center">🔐 Admin Login</h4>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="mb-3">
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-100">Login</button>
      </form>
    </div>
  );
}

export default Login;
